import { render, staticRenderFns } from "./SoluxPayStatus.vue?vue&type=template&id=71090470&"
import script from "./SoluxPayStatus.vue?vue&type=script&lang=js&"
export * from "./SoluxPayStatus.vue?vue&type=script&lang=js&"
import style0 from "./SoluxPayStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports